import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$stateProvider',
  function (runtimeConstant, $stateProvider) {
    function run() {
      try {
        $stateProvider
          .state('run', {
            abstract: true,
            url: '/workflow/run',
            templateUrl: 'views/modules/flow/execution/base.html',
            controller: 'adminController',
          })
          .state('run.workflow', {
            url: '/:guid',
            templateUrl: 'views/modules/flow/execution/content.html',
            controller: 'runWorkflowController',
            data: {
              title: 'Executar workflow',
              permissions: {
                only: ['WORKFLOW'],
                redirectTo: 'home.list',
              },
            },
          })
          .state('flows', {
            abstract: true,
            url: '/workflow',
            templateUrl: 'views/modules/flow/base-flow.html',
            controller: 'adminController',
            data: {
              permissions: {
                only: ['WORKFLOW'],
                redirectTo: 'home.list',
              },
            },
          })
          .state('flows.base', {
            url: '',
            templateUrl: 'views/modules/flow/manage/content.html',
            controller: 'workflowBaseController',
            data: {
              title: 'Modulo de Workflows',
            },
            redirectTo: 'flows.base.tasks',
          })
          .state('flows.base.models', {
            url: '/models',
            templateUrl: 'views/modules/flow/manage/list.base.html',
            data: {
              title: 'Modelos de Workflow',
              listTemplate: 'views/modules/flow/manage/list.workflows.html',
              permissions: {
                only: ['ManageWorkflows'],
                redirectTo: 'flows.base',
              },
            },
            controller: 'workflowController',
          })
          .state('flows.base.executions', {
            url: '/running',
            templateUrl: 'views/modules/flow/manage/list.base.html',
            data: {
              title: 'FLOWS EXECUTIONS',
              listTemplate: 'views/modules/flow/manage/list.executions.html',
              permissions: {
                only: ['ManageWorkflows'],
                redirectTo: 'flows.base',
              },
            },
            controller: 'workflowController',
          })
          .state('flows.base.tasks', {
            url: '/tasks',
            templateUrl: 'views/modules/flow/manage/list.base.html',
            data: {
              title: 'Minhas tarefas',
              listTemplate: 'views/modules/flow/manage/list.tasks.html',
            },
            controller: 'workflowController',
          })
          .state('flows.designer', {
            url: '/designer',
            templateUrl: 'views/modules/flow/designer/home.html',
            controller: 'flowController',
            data: {
              permissions: {
                only: ['WORKFLOW'],
                redirectTo: 'home.list',
              },
            },
          })
          .state('flows.designer.new', {
            url: '/new',
            templateUrl: 'views/modules/flow/designer/new.html',
            data: {
              title: 'NEW FLOW',
              crudTitle: 'Teste',
              permissions: {
                only: ['ROLE_WORKFLOW'],
                redirectTo: 'flows.base',
              },
            },
          })
          .state('flows.designer.edit', {
            url: '/edit/:guid',
            templateUrl: 'views/modules/flow/designer/new.html',
            data: {
              title: 'EDIT FLOW',
              crudTitle: 'Teste',
            },
          })
          .state('flows.designer.clone', {
            url: '/clone/:guid/',
            templateUrl: 'views/modules/flow/designer/new.html',
            data: {
              title: 'CLONE FLOW',
              crudTitle: 'Teste',
              action: 'clone',
            },
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
